import { service } from '@ember/service';
import PersistAppointmentMixin from './-mixins/persist-appointment';
import Route from '@ember/routing/route';
import classic from 'ember-classic-decorator';

@classic
export default class RequestInformationRoute extends Route.extend(PersistAppointmentMixin) {
  @service media;
  @service request;
  @service session;
  @service pendingAppointment;

  templateName = '-request/information';

  model(params, transition) {
    transition.trigger(false, 'stopPreselectionLoading', transition);
    return this.getInformationModel();
  }
}
